<template>
  <div>
    <div class="page-section">
      <a-card :bordered="false" style="width: 100%" id="title-card">
        <template slot="title">
          <a-breadcrumb separator=">">
            <a-breadcrumb-item>
              <router-link to="/cliente/monitores/cotacoes">Home</router-link>
            </a-breadcrumb-item>
            <a-breadcrumb-item>Relatórios</a-breadcrumb-item>
            <a-breadcrumb-item class="order-page-title">{{ title }}</a-breadcrumb-item>
          </a-breadcrumb>
        </template>
        <template slot="extra">
          <div class="title-actions not-print">
            <a-button v-if="printable" type="default" @click="print">
              <i class="fa-solid fa-print"></i> Imprimir
            </a-button>
            <a-button v-if="exportable" :loading="exporting" :disabled="exporting || exportDisabled" @click="$emit('export')">
              <i v-if="!exporting" class="fa-solid fa-file-excel"></i>
              {{ exporting ? "Gerando Excel..." : "Exportar" }}
            </a-button>
            <a-button v-if="stats.length" type="default" :hidden="!isDesktop" @click="showTotalizadores = !showTotalizadores">
              <i class="fa-solid fa-calculator"></i>
              {{ showTotalizadores ? "Ocultar Totalizadores" : "Mostrar Totalizadores" }}
            </a-button>
            <a-button type="danger" @click="$emit('clear')">
              <i class="fa-solid fa-filter-circle-xmark"></i> Limpar Filtros
            </a-button>
            <a-button v-if="$slots.drawer" type="primary" @click="drawerVisible = true">
              <i class="fa-solid fa-filter"></i> Mais Filtros
            </a-button>
          </div>
        </template>

        <a-form layout="vertical" class="not-print" style="width: 100%" @submit.prevent="$emit('filter')">
          <a-row :gutter="[12, 12]">
            <slot name="filters" />
            <a-col flex="auto" class="actions-col">
              <a-form-item class="item-button">
                <div class="actions-right">
                  <a-button type="default" icon="search" @click="$emit('filter')">Filtrar</a-button>
                </div>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>

        <AdvancedFiltersDrawer
          v-if="$slots.drawer"
          :visible.sync="drawerVisible"
          @apply="$emit('filter')"
          @clear="$emit('clear')"
        >
          <a-row :gutter="16">
            <slot name="drawer" />
          </a-row>
        </AdvancedFiltersDrawer>
      </a-card>
    </div>

    <div v-if="stats.length" class="page-section">
      <StatsCards
        :items="stats"
        :showTotalizadores="showTotalizadores"
        :selectedKeys="selectedStats"
        :nowrap="statsNowrap"
        dynamic-width
        @click="(key) => $emit('stat-click', key)"
      />
      <div v-if="statsHint && showTotalizadores" class="report-shell__hint not-print">{{ statsHint }}</div>
    </div>

    <div class="page-section">
      <a-card :bordered="false" style="width: 100%" class="table-card">
        <div class="table-container">
          <slot />
        </div>
      </a-card>
    </div>
  </div>
</template>

<script>
import StatsCards from "@/components/cliente/monitors/StatsCards.vue";
import AdvancedFiltersDrawer from "@/components/cliente/monitors/AdvancedFiltersDrawer.vue";

/**
 * Moldura das páginas do submenu Relatórios, no mesmo padrão do Diagnóstico:
 * card de título (breadcrumb + ações), filtros compactos com "Filtrar",
 * "Mais Filtros" num drawer, totalizadores em StatsCards e a tabela num card.
 */
export default {
  name: "ReportShell",
  components: { StatsCards, AdvancedFiltersDrawer },
  props: {
    title: { type: String, required: true },
    stats: { type: Array, default: () => [] },
    selectedStats: { type: Array, default: () => [] },
    statsHint: { type: String, default: "" },
    statsNowrap: { type: Boolean, default: false },
    printable: { type: Boolean, default: true },
    exportable: { type: Boolean, default: true },
    exporting: { type: Boolean, default: false },
    exportDisabled: { type: Boolean, default: false },
  },
  data() {
    return {
      drawerVisible: false,
      showTotalizadores: true,
      isDesktop: window.innerWidth >= 720,
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.isDesktop = window.innerWidth >= 720;
    },
    print() {
      window.print();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/sass/commons/_list-page-v2";

#title-card ::v-deep .ant-card-head-wrapper {
  flex-wrap: wrap;
}

#title-card ::v-deep .ant-card-extra {
  margin-left: auto;
}

.report-shell__hint {
  color: #8c8c8c;
  font-size: 0.75rem;
  margin-top: 6px;
}

// sem a tabela própria do a-table (o detalhamento expandido não convive com
// :scroll), quem rola na horizontal é o container
.table-container {
  overflow-x: auto;
}

::v-deep .ant-table-pagination.ant-pagination {
  margin: 12px 16px;
}

::v-deep .ant-select,
::v-deep .ant-input-affix-wrapper {
  width: 100%;
}

@media print {
  .table-container {
    max-height: none;
    overflow: visible;
  }
}
</style>
